export const getDandadSubNavLinks = () => {
    return [
        {to: '/dandad2020/presidents-message/', label: 'President’s message'},
        {to: '/dandad2020/chairmans-letter/', label: 'Chairman’s letter'},
        {to: '/dandad2020/d-ad-in-2020/', label: 'D&AD in 2020'},
    ]
}